export default 'sku,availability,manufacturer,image,minOrderQuantity,maxOrderQuantity,stepQuantity,inStock,promotions,packingUnit,mastered,productMaster,productMasterSKU,roundedAverageRating,retailSet,defaultCategory';
